<!-- TABLE CARD -->
<div>
  <div class="bg-white border-t border-gray-100 mb-2">
    <mat-paginator [length]="totalItems" [pageSize]="pageSize" [pageIndex]="currentPage - 1"
      [pageSizeOptions]="[pageSize]" showFirstLastButtons (page)="onPageChange($event)"
      [disabled]="isLoading || totalItems <= pageSize">
    </mat-paginator>
  </div>

  <!-- HEADER -->
  <div class="hidden md:grid grid-cols-12 bg-gray-50 border-b border-gray-200
              text-gray-600 px-3 py-2 text-sm font-medium">
    <!-- <div class="col-span-">ID</div> -->
    <div class="col-span-5">Post</div>
    <div class="col-span-2">Format</div>
    <div class="col-span-3 pl-4">Alert</div>
    <div class="col-span-1 text-center">Action</div>
  </div>

  <!-- LOADING -->
    <div *ngIf="isLoading" class="flex flex-col justify-center items-center text-center py-10 text-gray-400 animate-pulse">
      <div class="animate-spin h-8 w-8 border-4 border-gray-300 border-t-gray-700 rounded-full mb-2"></div>
      Loading Alerts
    </div>

  <!-- EMPTY STATE -->
  <div *ngIf="!isLoading && tableAlerts.length === 0" class="p-4 text-center text-gray-400 text-sm italic">
    No alerts found
  </div>

  <!-- ROWS -->
  <div *ngFor="let alert of tableAlerts" class="grid md:grid-cols-12 px-3 py-2 border-b border-gray-100 text-sm">

    <!-- POST -->
    <div class="grid grid-cols-12 md:col-span-5 gap-2 items-center">

      <!-- IMAGE -->
      <div class="col-span-3">

        <ng-container *ngIf="!(alert.source === 'form' && alert.format === 'photolink')
                   && alert.rss_img_url;
                   else noImage">

          <img [src]="alert.rss_img_url" class="w-12 h-12 object-cover rounded" alt="" />

        </ng-container>

        <ng-template #noImage>
          <img src="assets/screens/no-image-alert.png" class="w-12 h-12 object-cover rounded border border-gray-200"
            alt="No image" />
        </ng-template>

      </div>

      <!-- TITLE + DATE -->
      <div class="col-span-9 leading-tight">

        <p class="text-[13px] font-semibold text-gray-800
                   max-w-[280px] cursor-default" [matTooltip]="alert.rss_title" matTooltipPosition="above"
          matTooltipShowDelay="300">
          {{ alert.rss_title }}
        </p>

        <p class="text-[12px] text-gray-400">
          {{ alert.created_at | date:'yyyy-MM-dd HH:mm' }}
        </p>

      </div>

    </div>

    <!-- FORMAT -->
    <div class="hidden md:flex md:col-span-2 items-center
               text-[13px] text-gray-700 max-w-[160px]" [matTooltip]="formatLabel(alert.format)"
      matTooltipPosition="above" matTooltipShowDelay="300">

      <span class="truncate">
        {{ formatLabel(alert.format) }}
      </span>

    </div>

    <!-- ALERT -->
    <div class="grid md:col-span-3 pl-4 text-[13px] gap-1">

      <!-- TYPE LINE -->
      <div class="flex items-center gap-1 font-medium" [ngClass]="{
         'text-red-600': alert.alert_type.startsWith('Low'),
         'text-green-600': alert.alert_type.includes('Spike')
       }">

        <span class="text-sm">
          {{ alert.alert_type.includes('Spike') ? '▲' : '▼' }}
        </span>

        <span>
          {{ alert.alert_type }}
        </span>
      </div>

      <!-- METRIC LINE -->
      <div class="text-xs text-gray-500">
        {{ alert.alert_text }}
      </div>

    </div>

    <!-- ACTION -->
<div class="md:col-span-1 grid grid-flow-col auto-cols-max items-center justify-center gap-2">
  <button
    class="px-2 py-1 text-xs
           border border-gray-300 rounded
           text-gray-600 hover:bg-gray-100
           transition cursor-pointer"
    (click)="dismissAlert(alert.id)">
    Dismiss
  </button>

  <button
    class="px-2 py-1 text-xs
           border border-gray-300 rounded
           text-gray-600 hover:bg-gray-100
           transition cursor-pointer"
    (click)="viewAlert(alert)">
    View
  </button>
</div>


  </div>

  <div class="bg-white border-t border-gray-100 mt-2">
    <mat-paginator [length]="totalItems" [pageSize]="pageSize" [pageIndex]="currentPage - 1"
      [pageSizeOptions]="[pageSize]" showFirstLastButtons (page)="onPageChange($event)"
      [disabled]="isLoading || totalItems <= pageSize">
    </mat-paginator>
  </div>

</div>
